import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiClient } from './client';
import { Person, CreatePersonDto } from '../types/api';

export const usePerson = (id: string) => {
    return useQuery({
        queryKey: ['person', id],
        queryFn: async () => {
            const { data } = await apiClient.get<Person>(`/person/${id}`);
            return data;
        },
        enabled: !!id,
    });
};

export const useCreatePerson = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (dto: CreatePersonDto) => {
            const { data } = await apiClient.post<Person>('/person', dto);
            return data;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['tree'] });
        },
    });
};

export const useUpdatePerson = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ id, dto }: { id: string; dto: Partial<CreatePersonDto> }) => {
            const { data } = await apiClient.put<Person>(`/person/${id}`, dto);
            return data;
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['person', variables.id] });
            queryClient.invalidateQueries({ queryKey: ['tree'] });
        },
    });
};

export const useDeletePerson = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (id: string) => {
            await apiClient.delete(`/person/${id}`);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['tree'] });
        },
    });
};
